import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

const MarkdownSupport ={
    Telephone: ({content}: {content: string}) =>{
        const phone = content.replace(/.*: +\+84/,'')?.replace(/()/,'')
        return( <li>{content}
            {/* <a href={`tel:${phone}`} className="text-base"style={{color:"#00001F", textDecoration: "unset"}}>{content}</a> */}
        </li>)
    },
    Mailer: ({content}:{content?: any}) =>{
        const email = content?.toString()?.replace(/.*: /,'')?.replace(/() /,'')

        return( <li>
            <a href={`mailto:${email}?subject=VNIS&body=Message"`} style={{color:"#00001F", textDecoration: "unset"}}>{content}</a>
        </li>)
    }
}

const regexPhone = /(hotline|tel|phone)/
const regexEmail = /(email|mail|gmail)/

const MarkdownListItem: React.FunctionComponent = ({ children }) => {
    const regx = new RegExp(/\[(.*?)\]/)
    const text = children?.toString().replace(regx, "")

    if(text?.toLowerCase()?.match(regexPhone)) return <MarkdownSupport.Telephone content={text}/>
    if(text?.toLowerCase()?.match(regexEmail)) return <MarkdownSupport.Mailer content={text}/>

    const matched = children?.toString().match(regx) || [] as any

    const regexTooltip = new RegExp(/\[data-tooltip=*?/g)
    const isEnableTooltip = children?.toString()?.match(regexTooltip)
    if (isEnableTooltip && isEnableTooltip[0] !== null) {
        let explaination = ""
        matched[1]?.split("|").map((item: any) => {
            const attr = item.split("=")
            if (attr[0] === "data-tooltip") {
                explaination += attr[1]
            }
        })
        return (
            <div className="d-flex row-description">
                <OverlayTrigger placement={"right"} overlay={(
                    <Tooltip id="info" className="explaination" arrowProps={
                        {
                            style: {
                                backgroundColor: "#FFF"
                            }
                        }
                    }>
                        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{explaination}</ReactMarkdown>
                    </Tooltip>)}>
                    <span>{text}</span>
                </OverlayTrigger>
            </div>
        )
    }

    switch (undefined) {
        case matched[1]:
            return <li>{text}</li>
        default:
            const args = matched[1].split("|").map((item: any) => {
                const attr = item.split("=")
                return ({ [attr[0]]: attr[1] })
            })

            return <li {...Object.assign({}, ...args)} >{text}</li>
    }
}

export default MarkdownListItem